import {Component, Input, OnInit, TemplateRef} from '@angular/core';
import {AbstractFieldComponent} from '../../abstract/abstract-field.component';
import {FormFieldService} from '../../../services/form-field.service';
import {RadioCheckboxTileConfig} from '../../../models/field-config';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

@Component({
  selector: 'app-radio-checkbox-tile',
  templateUrl: './radio-checkbox-tile.component.html',
  styleUrls: []
})
export class RadioCheckboxTileComponent extends AbstractFieldComponent implements OnInit {

  @Input() content: TemplateRef<any>;
  @Input() contentData: any[];

  isSingleOption: boolean;

  get radioCheckboxTileConfig(): RadioCheckboxTileConfig {
    return this.fieldConfig.radioCheckboxTileConfig;
  }

  get checkboxMode(): boolean {
    if (this.radioCheckboxTileConfig) {
      return isNotNullOrUndefined(this.radioCheckboxTileConfig.checkboxDisabled) ? !this.radioCheckboxTileConfig.checkboxDisabled : true;
    }
    return true;
  }

  get errorVisible(): boolean {
    return isNotNullOrUndefined(this.errorsMap.get(this.fieldConfig.fieldKey));
  }

  constructor(public formFieldService: FormFieldService) {
    super(formFieldService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.init();
    this.handleStatusChanges();
  }

  async valueLabel() {
    if (this.radioCheckboxTileConfig && this.radioCheckboxTileConfig.getAnalyticsFieldValue && !!this.control.value) {
      const contentDataValuePropertyName = this.radioCheckboxTileConfig.contentDataValuePropertyName ? this.radioCheckboxTileConfig.contentDataValuePropertyName : 'value';
      const selectedItem = this.contentData.find(item => item[contentDataValuePropertyName] === this.control.value);
      return selectedItem ? this.radioCheckboxTileConfig.getAnalyticsFieldValue(selectedItem) : this.control.value;
    }
    return this.control.value;
  }

  async onClick(event) {
    setTimeout(() => super.onClick(event), 0);
  }

  private init(): void {
    this.isSingleOption = this.fieldConfig.radioConfig ? this.fieldConfig.radioConfig.length === 1 : false;
  }

}
